<template>
    <Layout>
        <template slot="body">
            <div class="card card-modern pt-3" style="border: none; box-shadow: none;">
                <div class="modern-header" style="display: flex; align-items: center; gap: 15px; margin-bottom: 20px;">
                    <div class="header-icon" style="background: #fff7ed; color: #ff9800; width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center;">
                        <i class="material-icons" style="font-size: 24px; margin: 0;">lock</i>
                    </div>
                    <h4 class="card-title" style="margin: 0; font-size: 1.5rem; color: #1e293b;">Alterar senha</h4>
                </div>
                <div class="card-body">
                    <div class="form-group has-default">
                        <div class="input-group">
                            <input id="input-senha-atual" v-model="senhaAtual" type="password" placeholder="Senha atual" class="form-control">
                        </div>
                    </div>

                    <div class="form-group has-default">
                        <div class="input-group">
                            <input id="input-nova-senha" v-model="novaSenha" type="password" placeholder="Nova senha" class="form-control">
                        </div>
                    </div>

                    <div class="form-group has-default">
                        <div class="input-group">
                            <input id="input-confirmar-senha" v-model="confirmarSenha" type="password" placeholder="Confirmar senha" class="form-control">
                        </div>
                    </div>

                    <div v-show="success" class="mt-3" style="margin: auto;">
                        <span style="font-weight: bold; margin: auto;">Senha alterada com sucesso!</span>
                    </div>

                    <div v-show="errors" class="mt-3">
                        <ul>
                            <li v-for="(error, i) in errors" :key="i">
                                <span style="font-weight: bold; color: red;">{{ error }}</span>
                            </li>
                        </ul>
                    </div>

                    <button id="actionButton" v-on:click="alterarSenha" style="width: 200px;" class="btn-solar mt-3">Alterar senha</button>
                </div>
            </div>
        </template>
    </Layout>
</template>

<script>
    import Layout from "@/components/layout/Layout.vue";

    export default {
        data() {
            return {
                senhaAtual: null,
                novaSenha: null,
                confirmarSenha: null,
                success: false,
                errors: []
            }
        },
        methods: {
            alterarSenha() {
                if (this.senhaAtual == null || this.senhaAtual == '') {
                    document.getElementById('input-senha-atual').setCustomValidity('Informe a senha atual');
                    document.getElementById('input-senha-atual').reportValidity();
                    document.getElementById('input-senha-atual').focus();
                    return false;
                } else {
                    document.getElementById('input-senha-atual').setCustomValidity('');
                }

                if (this.novaSenha == null || this.novaSenha == '') {
                    document.getElementById('input-nova-senha').setCustomValidity('Informe a nova senha');
                    document.getElementById('input-nova-senha').reportValidity();
                    document.getElementById('input-nova-senha').focus();
                    return false;
                } else {
                    document.getElementById('input-nova-senha').setCustomValidity('');
                }

                if (this.confirmarSenha == null || this.confirmarSenha == '') {
                    document.getElementById('input-confirmar-senha').setCustomValidity('Confirme a nova senha');
                    document.getElementById('input-confirmar-senha').reportValidity();
                    document.getElementById('input-confirmar-senha').focus();
                    return false;
                } else {
                    document.getElementById('input-confirmar-senha').setCustomValidity('');
                }

                var formData = {
                    'current_password': this.senhaAtual,
                    'new_password': this.novaSenha,
                    'new_confirm_password': this.confirmarSenha,
                };

                callAPI(
                    "/alterar-senha",
                    "put",
                    formData,
                    (res) => {
                        if ( res.success ) {
                            this.success = true;
                            this.errors = null;
                        } else {
                            this.success = false;
                            this.errors = res.errors;
                        }
                    },
                    (res) => {},
                    (res) => {
                        this.success = false;
                        for (var key in res.responseJSON.errors) {
                            for ( const error of res.responseJSON.errors[key] ) {
                                this.errors.push(error);
                            }
                        }
                    }
                );
            }
        },
        components: {
            Layout
        },
    };
</script>